export const GET_TODOS = 'GET_TODOS' 
export const SAVE_TODOS = 'SAVE_TODOS'
export const DELETE_TODO = 'DELETE_TODOS'
export const ADD_TODO = 'ADD_TODOS'
export const COMPLETE_TODO = 'COMPLETE_TODO'
